import React from "react"
import { Card, CardItem, Alert } from "@walmart-web/livingdesign-components"
import { withRouter } from "react-router-dom"
import "./LoginSelector.scss"
import { redirectToPingFedSSO } from "helpers/authUtils"
import { HOME, PHRONESIS_LOGIN } from "constants/paths"
import { useIntl, FormattedMessage } from "react-intl"
import { ReactComponent as LoginIcon } from "assets/images/login_icon.svg"
import LoginExpirationMessage from "./LoginExpirationMessage"
import {
	FetchedFeatureFlags,
	isFetchedFeatureEnabled,
} from "config/feature-flags"
import { redirect } from "navigation/redirect"
import config from "config/config"
import { useQueries } from "react-query"
import { DynamicConfigs, getDynamicConfig } from "config/dynamic-config"
import Button from "components/Shared/LivingDesign/Button"

function LoginSelector(props) {
	const originUrl = props?.location?.state?.from?.pathname || HOME
	const className = "login-selector"
	const intl = useIntl()
	const [
		{ data: isBannerActive, isLoading: isBannerActiveLoading },
		{ data: authReleaseDay, isLoading: isAuthReleaseDayLoading },
	] = useQueries([
		{
			queryKey: "migration_banner_enabled",
			queryFn: async () =>
				await isFetchedFeatureEnabled(
					FetchedFeatureFlags.MigrationBannerEnabled
				),
		},
		{
			queryKey: "auth_release_day",
			queryFn: async () =>
				await getDynamicConfig(DynamicConfigs.AuthReleaseDay),
		},
	])

	const showBanner =
		isBannerActive && !isBannerActiveLoading && !isAuthReleaseDayLoading

	const providerLoginAuthSwitchHandler = async () => {
		return redirect(`${config.base_url}${PHRONESIS_LOGIN}`)
	}
	return (
		<div data-testid="container-login-selector" className={`${className}`}>
			<Card size="medium" UNSAFE_className={`${className}-card-login`}>
				{showBanner && (
					<div className="migration-alert" data-testid="alert-banner">
						<Alert variant="warning">
							<div className="migration-alert-content">
								<FormattedMessage
									id="phronesis.login.landing.migrationAlert"
									values={{
										b: (text) => <b>{text}</b>,
										date: authReleaseDay,
									}}
								/>
							</div>
						</Alert>
					</div>
				)}
				<LoginIcon className="imageSVG" />
				<CardItem UNSAFE_className="login-selector-card-item">
					<h1 className="login-selector-title">
						{intl.formatMessage({
							id: "phronesis.login.landing.title",
						})}
					</h1>
					<h4>
						{intl.formatMessage({
							id: "phronesis.login.landing.subtitle",
						})}
					</h4>
					<div className="login-selector-options">
						<Button
							onClick={() => providerLoginAuthSwitchHandler()}
							variant="primary"
							size="medium"
							UNSAFE_className="login-selector-vendor"
						>
							<FormattedMessage id="phronesis.login.landing.provider" />
						</Button>
						<Button
							onClick={() => redirectToPingFedSSO(originUrl)}
							variant="secondary"
							size="medium"
						>
							<FormattedMessage id="phronesis.login.landing.walmart" />
						</Button>
					</div>
					<LoginExpirationMessage />
				</CardItem>
			</Card>
		</div>
	)
}

export default withRouter(LoginSelector)
